import React, { useState, useEffect } from "react";
import Layout from "components/sales/layout/layout";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import TableSection from "components/sales/tableSection/tableSection";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { toast } from "react-toastify";

const METHOD = "ADD";
const SOURCE = "toa";
const CATEGORY_ID = "11";
const SUB_CATEGORY_ID = "48220";
const ACTION = "inactive";
const SKU_PREPAID = "pre_order_supertag_issuance";
const SKU_NORMAL = "supertag_issuance";
const REQUEST_CHANNEL = "fusion";
const FSE_PROJECT_MAPPING_SAMPLE_CSV =
  "https://parkplus-project-images.parkplus.io/parkplus-money/public/testing_20260910174200088823_6f943556-f50e-4b33-94b0-235875957e15.csv";
const SBI_AGENT_PORTAL_SAMPLE_CSV =
  "https://parkplus-project-images.parkplus.io/parkplus-money/public/testing_20260921173443167151_b6a8a232-cb9d-495a-aa66-1acdb249b9ff.csv";
const FILE_LINK_UPLOAD_TYPE_IDS = [11, 12, 13];

const buildFormData = (typeId, csvFile) => {
  const formData = new FormData();
  let payload = {};

  if (typeId === 3) {
    payload = {
      action: ACTION,
      csv_file: csvFile,
      request_channel: REQUEST_CHANNEL,
    };
  } 
  else if (typeId === 8 || typeId === 9) {
    payload = {
      csv_file: csvFile,
    };
  }
  else if (typeId === 11) {
    payload = {
      file_link: csvFile,
    };
  }
  else if (typeId === 12 || typeId === 13) {
    payload = {
      file_link: csvFile,
      operation: typeId === 12 ? "UPDATE/NEW" : "REMOVE",
    };
  }
  else {
    payload = {
      method: METHOD,
      source: SOURCE,
      category_id: CATEGORY_ID,
      sub_category_id: SUB_CATEGORY_ID,
      sku: typeId === 1 ? SKU_PREPAID : SKU_NORMAL,
      csv_file: csvFile,
      request_channel: REQUEST_CHANNEL,
    };
  }
  Object.entries(payload).forEach(([key, value]) => {
    if (key === "csv_file" && value) {
      formData.append("csv_file", value);
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};

const FasTagPricing = ({
  submitFastagPricing,
  transferTagRequest,
  fastagPricingResponse = [],
  fetchUserDetailsById,
  fetchUserDetailsByIdResponse = [],
  addCashbackForFastag,
  deleteCashbackForFastag,
  reAssignUserForFastag,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const [typeId, setTypeId] = useState("");
  const [error, setError] = useState("");
  const [submitError, setSubmitError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [failureModal, setFailureModal] = useState(false);
  const [csvFile, setFile] = useState(null);
  const [transferFormData, setTransferFormData] = useState({
    transfer_from_role_id: "",
    transfer_from_user_id: "",
    transfer_from_user_name: "",
    transfer_to_role_id: "",
    transfer_to_user_id: "",
    transfer_to_user_name: "",
    bar_codes: "",
    action: "REALLOCATE",
  });
  const [showTable, setShowTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(50);
  const [pageCount, setPageCount] = useState(0);
  const [tableData, setTableData] = useState([]);

  // Separate state for user details responses
  const [transferFromUserDetails, setTransferFromUserDetails] = useState(null);
  const [transferToUserDetails, setTransferToUserDetails] = useState(null);
  const [lastFetchedField, setLastFetchedField] = useState(null);

  const selectFastagType = [
    { id: 1, name: "Prepaid Price Set" },
    { id: 2, name: "Normal Price Set" },
    { id: 3, name: "Tag Removal" },
    { id: 4, name: "Tag Transfer" },
    { id: 5, name: "Add Cashback" },
    { id: 6, name: "Delete Cashback" },
    { id: 7, name: "Re-Assign User" },
    { id: 8, name: "Deactivate Bundle" },
    { id: 9, name: "Update Bundle Price" },
    { id: 10, name: "Remove SBI Replacement Tags" },
    { id: 11, name: "Fse (project Id) mapping" },
    { id: 12, name: "Add SBI Agent" },
    { id: 13, name: "Remove SBI Agent" },
  ];

  const roleIdArray = [
    { id: 1199, name: "fastag_asm" },
    { id: 1200, name: "fastag_am" },
    { id: 1204, name: "fastag_jm" },
    { id: 1201, name: "fastag_tl" },
    { id: 1135, name: "supertag_agent" },
  ];

  // Watch for API response and update appropriate state
  useEffect(() => {
    if (
      fetchUserDetailsByIdResponse &&
      Object.keys(fetchUserDetailsByIdResponse).length > 0
    ) {
      if (lastFetchedField === "transfer_from") {
        setTransferFromUserDetails(fetchUserDetailsByIdResponse);
      } else if (lastFetchedField === "transfer_to") {
        setTransferToUserDetails(fetchUserDetailsByIdResponse);
      }
    }
  }, [fetchUserDetailsByIdResponse, lastFetchedField]);

  // Debouncing for transfer_from_user_id
  useEffect(() => {
    if (!transferFormData.transfer_from_user_id || typeId !== 4) {
      setTransferFromUserDetails(null);
      return;
    }

    const debounceTimer = setTimeout(async () => {
      try {
        const userId = transferFormData.transfer_from_user_id;
        if (userId && userId.toString().trim().length > 0) {
          setLastFetchedField("transfer_from");
          await fetchUserDetailsById(userId);
        }
      } catch (err) {
        // console.error("Error fetching transfer_from user details:", err);
        toast.error(err);
        setTransferFromUserDetails(null);
      }
    }, 500); // 500ms debounce delay

    return () => clearTimeout(debounceTimer);
  }, [transferFormData.transfer_from_user_id, typeId]);

  // Debouncing for transfer_to_user_id
  useEffect(() => {
    if (!transferFormData.transfer_to_user_id || typeId !== 4) {
      setTransferToUserDetails(null);
      return;
    }

    const debounceTimer = setTimeout(async () => {
      try {
        const userId = transferFormData.transfer_to_user_id;
        if (userId && userId.toString().trim().length > 0) {
          setLastFetchedField("transfer_to");
          await fetchUserDetailsById(userId);
        }
      } catch (err) {
        console.error("Error fetching transfer_to user details:", err);
        setTransferToUserDetails(null);
      }
    }, 500); // 500ms debounce delay

    return () => clearTimeout(debounceTimer);
  }, [transferFormData.transfer_to_user_id, typeId]);

  // Auto-fill transfer_from user details
  useEffect(() => {
    if (transferFromUserDetails?.data) {
      const { role_id, first_name, last_name } = transferFromUserDetails.data;
      setTransferFormData((prev) => ({
        ...prev,
        transfer_from_role_id: role_id || "",
        transfer_from_user_name: `${first_name || ""} ${
          last_name || ""
        }`.trim(),
      }));
    }
  }, [transferFromUserDetails]);

  // Auto-fill transfer_to user details
  useEffect(() => {
    if (transferToUserDetails?.data) {
      const { role_id, first_name, last_name } = transferToUserDetails.data;
      setTransferFormData((prev) => ({
        ...prev,
        transfer_to_role_id: role_id || "",
        transfer_to_user_name: `${first_name || ""} ${last_name || ""}`.trim(),
      }));
    }
  }, [transferToUserDetails]);

  const isCsvRequired = typeId;
  const handleCsvUploadFileOnly = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!selectedFile.name.toLowerCase().endsWith(".csv")) {
      setError("Only CSV files are allowed!");

      setFile(null);
      return;
    }

    setError("");
    setFile(selectedFile);
  };

  const onSubmit = async () => {
    setShowConfirm(false);

    if (!typeId) {
      setSubmitError(true);
      return;
    }

    if ([1, 2, 3, 8, 9, 10, 11, 12, 13].includes(typeId) && !csvFile) {
      setError("Please upload a CSV file!");
      return;
    }

    setSubmitError(false);
    setIsLoading(true);

    try {
      const formData = buildFormData(typeId, csvFile);
      if (typeId == 4) {
        const tagTransferResponse = await transferTagRequest(transferFormData);
        if (tagTransferResponse?.data?.status == 0) { 
          setSuccessModal(true);
        } else {
          toast.error(tagTransferResponse?.data?.message);
        }
      } else if (typeId == 5) {
        // Add Cashback
        const addCashBackPayload = {
          'action': 'ADD'
        }
        const addCashbackResponse = await addCashbackForFastag(addCashBackPayload);
        if (addCashbackResponse?.status == 0) { 
          setSuccessModal(true);
        } else {
          toast.error(addCashbackResponse?.message);
        }
      } else if (typeId == 6) {
        // Delete Cashback
        const deleteCashBackPayload = {
          'action': 'DELETE'
        }
        const deleteCashbackResponse = await deleteCashbackForFastag(deleteCashBackPayload);
        if (deleteCashbackResponse?.status == 0) { 
          setSuccessModal(true);
        } else {
          toast.error(deleteCashbackResponse?.message);
        }
      } else if (typeId == 7) {
        // Re-Assign User
        const reAssignUserPayload = {
          'source': 'SHEET'
        }
        const reAssignUserResponse = await reAssignUserForFastag(reAssignUserPayload);
        if (reAssignUserResponse?.status == 0) { 
          setSuccessModal(true);
        } else {
          toast.error(reAssignUserResponse?.message);
        }
      } else {
        await submitFastagPricing(typeId, formData);

        // Show table only for typeId === 3
        if (typeId === 3) {
          setShowTable(true);
        }
        setSuccessModal(true);
      }
    } catch (err) {
      const apiErrorMessage =
        err.response?.data?.message ||
        err.message ||
        "Something went wrong. Try again.";

      setError(apiErrorMessage);
      setFailureModal(true);
    }
    setIsLoading(false);
  };

  return (
    <Layout
      title="FASTag Pricing/Inventory"
      Buttons={() => <></>}
      isLoading={isLoading}
    >
      <div className="container mt-2">
        <div className="row d-flex" style={{ justifyContent: "space-between" }}>
          <div className={typeId === 4 ? "col-md-12" : "col-md-8"}>
            <DropDownInput
              label="Select Type"
              data={selectFastagType}
              required
              isStarRequired={true}
              errorMsg="Required"
              getIdValue={(val) => {
                setTypeId(val.id);
                setError("");
                setFile(null);
                setShowTable(false);
                setCurrentPage(1);
                setTransferFromUserDetails(null);
                setTransferToUserDetails(null);
                setTransferFormData({
                  ...transferFormData,
                  transfer_from_role_id: "",
                  transfer_from_role_name: "",
                  transfer_from_user_id: "",
                  transfer_from_user_name: "",
                  transfer_to_role_id: "",
                  transfer_to_role_name: "",
                  transfer_to_user_id: "",
                  transfer_to_user_name: "",
                  bar_codes: "",
                });
              }}
            />
          </div>

          {typeId && ![4, 5, 6, 7].includes(typeId) && (
            <div className="col-md-2">
              {FILE_LINK_UPLOAD_TYPE_IDS.includes(typeId) ? (
                <FileUpload
                  id="fse-bulk-mapping-csv"
                  accept=".csv,text/csv"
                  documentUploadUrl={documentUploadUrlPublic}
                  documentUrlData={documentUrlDataPublic}
                  onChange={(fileLink) => {
                    setFile(fileLink || null);
                    setError("");
                  }}
                >
                  <span className="btn btn-secondary w-auto">Upload CSV</span>
                </FileUpload>
              ) : (
                <label className="btn btn-secondary w-auto">
                  {csvFile ? csvFile.name : "Upload CSV"}
                  <input
                    type="file"
                    accept=".csv"
                    style={{ display: "none" }}
                    onChange={handleCsvUploadFileOnly}
                  />
                </label>
              )}
              {FILE_LINK_UPLOAD_TYPE_IDS.includes(typeId) && (
                <div className="mt-2">
                  <a
                    href={
                      typeId === 11
                        ? FSE_PROJECT_MAPPING_SAMPLE_CSV
                        : SBI_AGENT_PORTAL_SAMPLE_CSV
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    Download sample file
                  </a>
                </div>
              )}
              {error && <p className="text-danger mt-2">{error}</p>}
            </div>
          )}
        </div>
        {typeId === 4 && (
          <>
            <div className="row">
              <div className="col-md-4">
                <ConstantInput
                  label={"Tranfer From User ID"}
                  type="number"
                  required
                  isStarRequired={true}
                  handleChange={(value) => {
                    setTransferFormData({
                      ...transferFormData,
                      transfer_from_user_id: value,
                    });
                  }}
                />
              </div>
              <div className="col-md-4">
                <ConstantInput
                  label={"Transfer From User Name"}
                  type="text"
                  required
                  isStarRequired={true}
                  value={transferFormData.transfer_from_user_name || ""}
                  disabled={true}
                  handleChange={() => {}}
                />
              </div>
              <div className="col-md-4">
                <DropDownInput
                  label="Transfer From Role"
                  data={roleIdArray}
                  required
                  isStarRequired={true}
                  errorMsg="Required"
                  getValueById={transferFormData.transfer_from_role_id}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <ConstantInput
                  label={"Transfer To User ID"}
                  type="number"
                  required
                  isStarRequired={true}
                  handleChange={(value) => {
                    setTransferFormData({
                      ...transferFormData,
                      transfer_to_user_id: value,
                    });
                  }}
                />
              </div>
              <div className="col-md-4">
                <ConstantInput
                  label={"Transfer To User Name"}
                  type="text"
                  required
                  isStarRequired={true}
                  value={transferFormData.transfer_to_user_name || ""}
                  disabled={true}
                  handleChange={() => {}}
                />
              </div>
              <div className="col-md-4">
                <DropDownInput
                  label="Transfer To Role"
                  data={roleIdArray}
                  required
                  isStarRequired={true}
                  errorMsg="Required"
                  getValueById={transferFormData.transfer_to_role_id}
                  disabled={true}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <TextAreaInput
                  type="text"
                  rows={4}
                  label={"Bar Codes (separated by commas)"}
                  inputValue={transferFormData?.bar_codes}
                  isStarRequired={true}
                  handleChange={(e) =>
                    setTransferFormData({
                      ...transferFormData,
                      bar_codes: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </>
        )}

        <div className="row mt-3">
          <div className="col-md-6">
            <Button
              className="btn btn-primary"
              onClick={() => setShowConfirm(true)}
              disabled={
                !typeId ||
                !!error ||
                (typeId === 4
                  ? !transferFormData.transfer_from_role_id ||
                    !transferFormData.transfer_to_role_id ||
                    !transferFormData.transfer_from_user_id ||
                    !transferFormData.transfer_to_user_id ||
                    !transferFormData.bar_codes.trim()
                  : [1, 2, 3, 8, 9, 10, 11].includes(typeId) && !csvFile)
              }
            >
              Submit
            </Button>
          </div>
        </div>

        {submitError && (
          <div className="text-danger text-center mt-3">
            Please select type and upload CSV if required
          </div>
        )}
      </div>

      <ModalPop
        title="Confirmation"
        show={showConfirm}
        handleModalHide={() => setShowConfirm(false)}
        centered
      >
        <div className="text-center">
          <div className="">
            <img src={Images?.ConfirmationIcon} width={"15%"} alt="" />
          </div>
          <h4 className="mb-4">Are you sure you want to submit?</h4>

          <div className="d-flex justify-content-center">
            <Button
              className="btn btn-danger mx-2 px-4"
              onClick={() => setShowConfirm(false)}
            >
              No
            </Button>
            <Button className="btn btn-success mx-2 px-4" onClick={onSubmit}>
              Yes
            </Button>
          </div>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={successModal}
        handleModalHide={() => setSuccessModal(false)}
        centered
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>

          <h5>{localization.submittedSuccessfully}</h5>

          <Button
            onClick={() => {
              setSuccessModal(false);
              setTypeId("");
              setFile(null);
              setShowTable(false);
              setCurrentPage(1);
            }}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={failureModal}
        handleModalHide={() => setFailureModal(false)}
        centered
      >
        <div className="text-center">
          <h4 className="text-danger">
            {error && error.trim() !== "" ? error : localization.failed}
          </h4>

          <Button
            onClick={() => setFailureModal(false)}
            className="btn btn-secondary mb-4"
          >
            {localization.continue}
          </Button>
        </div>
      </ModalPop>

      {/* Table for Tag Removal response (typeId === 3) */}
      {showTable && typeId === 3 && fastagPricingResponse && (
        <TableSection
          data={(() => {
            const responseData =
              fastagPricingResponse?.data || fastagPricingResponse || [];
            const startIndex = (currentPage - 1) * limit;
            const endIndex = startIndex + limit;
            const paginatedData = responseData.slice(startIndex, endIndex);

            return paginatedData.map((item, index) => ({
              bar_code: item?.bar_code || "N/A",
              barcode_status: item?.status || "N/A",
              message: item?.message || "N/A",
            }));
          })()}
          isId={false}
          headers={["Bar Code", "Status", "Message"]}
          pageCount={Math.ceil(
            (fastagPricingResponse?.data?.length ||
              fastagPricingResponse?.length ||
              0) / limit
          )}
          srNo={limit * (currentPage - 1) + 1}
          onPageChange={(val) => setCurrentPage(val.selected + 1)}
        />
      )}
    </Layout>
  );
};

export default FasTagPricing;
